/* pillar.js: behaviour for sections/pillar-main.liquid + pillar-library.liquid (build spec v3).
   Filters, the "Find your stool" chooser (logic ported 1:1 from the approved mockup; every
   string, list, width and reason comes from the pillar.page JSON), the five "before you
   choose" cards and their detail dialogs, compare pickers, guides, FAQ, the mobile sticky
   bar and the samples drawer. No framework; the page works without this file. */
(function () {
  var root = document.querySelector('[data-plr]');
  if (!root) return;
  var lib = document.querySelector('[data-plr-lib]');
  var roots = [root, lib].filter(Boolean);
  roots.forEach(function (r) { r.classList.add('js'); });

  var D = JSON.parse(root.querySelector('[data-plr-data]').textContent);
  var T = D.ch.t, U = D.ui, M = D.models, R = D.root || '';
  var MOB = window.matchMedia('(max-width: 767px)');
  var KEY = 'plr:' + location.pathname.split('?')[0];
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return [].slice.call((el || document).querySelectorAll(s)); };
  // US market (pillar.page unit "in"): every length the page writes goes through fmt, so "66 cm" or
  // "50 to 60 cm" become inches here, to the nearest half inch. The finder still computes in cm.
  var IN = D.unit === 'in';
  function toIn(v) { return String(Math.round(v / 2.54 * 2) / 2); }
  function inch(s) {
    return !IN ? s : s.replace(/(\d+(?:\.\d+)?)((?:(?: to | and | or |, )\d+(?:\.\d+)?)*) ?cm\b/g, function (m, a, rest) {
      return toIn(+a) + rest.replace(/\d+(?:\.\d+)?/g, function (n) { return toIn(+n); }) + ' in';
    });
  }
  function fmt(s, o) { s = String(s == null ? '' : s); for (var k in o) s = s.split('%' + k).join(o[k]); return inch(s); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function cm(v) { return fmt(T.cm, { v: v }); }
  function noun(n) { return n === 1 ? U.noun[0] : U.noun[1]; }
  function ev(name, p) { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name, pillar: KEY }, p || {})); }
  function store(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(KEY + k)); sessionStorage.setItem(KEY + k, JSON.stringify(v)); } catch (e) { return null; } }
  var PROD = {};
  D.prod.forEach(function (p) { if (p.id && p.id !== '-' && !PROD[p.id]) PROD[p.id] = p; });
  var q = new URLSearchParams(location.search);
  ev('pillar_view', { locale: document.documentElement.lang });

  /* Sticky header offset for the chips, anchors and card targets. */
  var header = document.querySelector('.shopify-section-group-header-group[class*="main-header"], [id$="__main-header"]');
  function setHead() { var h = header ? Math.round(header.getBoundingClientRect().height) : 64; roots.forEach(function (r) { r.style.setProperty('--head', (h || 64) + 'px'); }); }
  setHead(); window.addEventListener('resize', setHead);
  function scrollToEl(el) {
    if (!el) return;
    var head = parseInt(getComputedStyle(root).getPropertyValue('--head'), 10) || 64;
    var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - head + 1, behavior: smooth ? 'smooth' : 'auto' });
  }

  /* ---------- samples drawer (the existing site drawer, never a new one) ---------- */
  function openSamples(source) {
    var tab = document.querySelector('.pdp-samples [data-samples-open]');
    if (!tab) return false;
    var drawer = tab.closest('.pdp-samples');
    if (!drawer.classList.contains('is-open')) tab.click();
    var grp = drawer.querySelector('[data-samples-group="fabric-samples"] details');
    if (grp) grp.open = true;
    ev('samples_open', { source: source || 'page' });
    return true;
  }
  window.byCrea = window.byCrea || {};
  if (!window.byCrea.openSamples) window.byCrea.openSamples = openSamples;
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-plr-samples]');
    if (a && openSamples(a.getAttribute('data-plr-samples'))) { e.preventDefault(); closeDetail(); }
    var g = e.target.closest && e.target.closest('[data-plr-guide]');
    if (g) ev('guide_click', { url: g.getAttribute('href'), source: g.getAttribute('data-plr-guide') });
  });

  /* ---------- filters ---------- */
  var grid = $('[data-plr-grid]', root), cards = $$('[data-card]', grid), tiles = $$('[data-tile]', grid);
  var chips = $$('[data-filter]', root), matchChip = $('[data-filter="match"]', root);
  var countEl = $('[data-plr-count]', root);
  var FILTERS = {
    all: function () { return true; }, oak: function (c) { return c.dataset.mat === 'oak'; }, steel: function (c) { return c.dataset.mat === 'steel'; },
    back: function (c) { return c.dataset.back && c.dataset.back !== 'none'; }, backless: function (c) { return c.dataset.back === 'none'; },
    arms: function (c) { return c.dataset.back === 'arms'; },
    match: function (c) { return matches && matches.indexOf(c.dataset.mid) > -1; }
  };
  var inspo = $('[data-plr-inspo]', root);
  var filter = 'all', matches = store(':matches');
  function setFilter(k, silent) {
    if (k === 'inspiration' && !inspo) k = 'all';
    if (k !== 'inspiration' && (!FILTERS[k] || (k === 'match' && !matches))) k = 'all';
    filter = k;
    var n = 0;
    if (inspo) { inspo.hidden = k !== 'inspiration'; grid.hidden = k === 'inspiration'; }
    if (k === 'inspiration') {
      inflateInspo();
      chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c.dataset.filter === k)); });
      countEl.textContent = fmt(U.inspo_count, { n: inspo.getAttribute('data-n') });
      var iu = new URL(location.href); iu.searchParams.set('filter', k); history.replaceState(history.state, '', iu);
      if (!silent) ev('pillar_filter', { key: k, count: +inspo.getAttribute('data-n') });
      return;
    }
    cards.forEach(function (c) {
      var on = FILTERS[k](c); c.hidden = !on; if (on) n++;
      c.style.order = k === 'match' && on ? String(matches.indexOf(c.dataset.mid)) : '';
    });
    tiles.forEach(function (t) { t.hidden = k !== 'all'; });
    chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c.dataset.filter === k)); });
    countEl.textContent = fmt(U.count_label, { n: n, u: noun(n) });
    var url = new URL(location.href);
    if (k === 'all' || k === 'match') url.searchParams.delete('filter'); else url.searchParams.set('filter', k);
    history.replaceState(history.state, '', url);
    if (!silent) ev('pillar_filter', { key: k, count: n });
  }
  function showMatchChip() {
    if (!matches) return;
    if (!matchChip) {
      var mt = $('template[data-plr-match-tpl]', root);
      if (!mt) return;
      mt.parentNode.insertBefore(mt.content.cloneNode(true), mt); mt.remove();
      matchChip = $('[data-filter="match"]', root);
      chips.push(matchChip);
      matchChip.addEventListener('click', function () { setFilter('match'); });
    }
    matchChip.hidden = false;
    $('[data-plr-nmatch]', root).textContent = matches.length;
    updSticky();
  }
  chips.forEach(function (c) { c.addEventListener('click', function () { setFilter(c.dataset.filter); }); });
  cards.forEach(function (c, i) { c.addEventListener('click', function () { ev('select_item', { item_id: c.dataset.mid, index: i + 1, list: 'pillar_grid', filter: filter }); }); });
  // The Inspiration photos ship inside a <template>, so the page's readable content lists each
  // product once (the grid); the mosaic only enters the DOM when a shopper opens it.
  function inflateInspo() {
    var tpl = inspo && $('template[data-plr-inspo-tpl]', inspo);
    if (!tpl) return;
    inspo.appendChild(tpl.content.cloneNode(true)); tpl.remove();
    $$('.plr-inspo__cell', inspo).forEach(function (c, i) { c.addEventListener('click', function () { ev('select_item', { item_id: c.dataset.inspoPid, index: i + 1, list: 'pillar_inspiration' }); }); });
  }
  showMatchChip();
  if (q.get('filter')) setFilter(q.get('filter'), true);
  function goShop(src) { closeChooser(); scrollToEl($('#shop')); if (src) ev('pillar_hero_cta', { cta: 'shop', source: src }); }
  $$('[data-plr-go]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); if (a.hasAttribute('data-plr-sticky-shop') && matches) setFilter('match'); goShop(a.getAttribute('data-plr-go')); }); });

  /* ---------- chooser ---------- */
  var chEl = $('[data-plr-ch]', root), entry = $('[data-plr-entry]', root);
  var BASE = { open: false, step: 1, counter: null, cVal: 95, len: 180, lenSkip: false, walls: 0, sit: null, mat: null };
  var ch = Object.assign({}, BASE, store(':ch') || {}, { open: false });
  var trigger = null;
  function save() { store(':ch', ch); }

  function seatInfo(c) {
    if (c.counter === 'std') return { seat: 66, custom: false, cTxt: T.opts1[0][1], leg: T.leg_std };
    if (c.counter === 'bar') return { seat: 76, custom: false, cTxt: T.opts1[1][1], leg: T.leg_std };
    if (c.counter === 'custom') {
      var v = c.cVal;
      if (v >= 89 && v <= 92) return { seat: 66, custom: false, v: v, cTxt: cm(v), leg: cm(v - 66) };
      if (v >= 99 && v <= 102) return { seat: 76, custom: false, v: v, cTxt: cm(v), leg: cm(v - 76) };
      return { seat: v - 25, custom: true, v: v, cTxt: cm(v), leg: cm(25) };
    }
    return null;
  }
  function counts(c) {
    if (c.lenSkip) return null;
    var eff = c.len - 10 * c.walls;
    return { eff: eff, slim: Math.floor(eff / 50), std: Math.floor(eff / 55), wide: Math.floor(eff / 60) };
  }
  function reason(id, sit) { var r = D.ch.reasons[id] || {}; return r[sit] || r.def || ''; }
  function rank(c, si) {
    var ids = (D.ch.rank[c.sit || 'none'] || D.ch.rank.none).filter(function (i) { return M[i]; });
    var custom = si && si.custom;
    if (custom && c.mat === 'oak') {
      var v = si.v, near = v - 76 >= 20 ? 76 : 66;
      var steel = ids.filter(function (i) { return M[i].material === 'steel'; }).slice(0, 2).map(function (i) { return { id: i, reason: reason(i, c.sit), sub: fmt(T.sub_custom, { s: si.seat }) }; });
      var oak = ids.filter(function (i) { return M[i].material === 'oak'; })[0];
      return { conflict: true, near: near, list: steel.concat([{ id: oak, reason: fmt(T.reason_oak_near, { h: near, g: v - near }), sub: fmt(T.sub_std_near, { h: near }) }]) };
    }
    var l = ids;
    if (custom || c.mat === 'steel') l = l.filter(function (i) { return M[i].material === 'steel'; });
    if (c.mat === 'oak') l = l.filter(function (i) { return M[i].material === 'oak'; });
    // Subcollection page: prefer the models on this page; if none fit the answers, keep the full-range pick.
    if (D.allow) { var a = l.filter(function (i) { return D.allow.indexOf(i) > -1; }); if (a.length) l = a; }
    var sub = custom ? fmt(T.sub_custom, { s: si.seat }) : (si ? fmt(T.sub_seat, { s: si.seat }) : T.sub_any);
    return { conflict: false, list: l.slice(0, 3).map(function (i) { return { id: i, reason: reason(i, c.sit), sub: sub }; }) };
  }
  function result(c) {
    var si = seatInfo(c), k = counts(c), rk = rank(c, si), top = M[rk.list[0].id];
    var n = k ? Math.floor(k.eff / top.spacing) : null, s1, s2 = '', bd = [], note = null, noteLabel = '';
    if (!si) s1 = T.why_unknown;
    else if (si.custom) s1 = fmt(T.why_custom, { v: si.v, s: si.seat });
    else s1 = fmt(T.why_std, { c: si.cTxt, l: si.leg, s: si.seat });
    if (k) {
      var pre = c.walls ? fmt(c.walls === 2 ? T.why_wall2 : T.why_wall1, { e: k.eff }) : fmt(T.why_len, { L: c.len });
      s2 = k.slim === k.std ? fmt(T.why_same, { p: pre, n: k.std, u: noun(k.std) }) : fmt(T.why_diff, { p: pre, n: k.std, s: k.slim, u: noun(k.std) });
      var out = [];
      [['slim', k.slim], ['std', k.std], ['wide', k.wide]].forEach(function (g) {
        var last = out[out.length - 1];
        if (last && last.v === g[1]) last.k.push(g[0]); else out.push({ k: [g[0]], v: g[1] });
      });
      if (out.length > 1) bd = out.map(function (o) {
        var lab = o.k.map(function (w, j) { return j ? T.widths_join[w] : T.widths[w]; }).join(' ' + T.or + ' ');
        return fmt(T.breakdown, { k: lab, n: o.v, u: noun(o.v) });
      });
    }
    if (rk.conflict) {
      var leg = si.v - rk.near;
      noteLabel = T.note_tradeoff_label;
      note = fmt(T.note_tradeoff, { v: si.v, h: rk.near, g: leg, x: leg > 26 ? T.note_low : T.note_tight, s: si.seat });
    } else if (si && si.custom) { noteLabel = T.note_custom_label; note = T.note_custom; }
    else if (!si) { noteLabel = T.note_unknown_label; note = T.note_unknown; }
    return { si: si, k: k, rk: rk, n: n, why: s1 + s2, bd: bd, note: note, noteLabel: noteLabel };
  }
  window.__plrLogic = { seatInfo: seatInfo, counts: counts, rank: rank, result: result };

  var ICON_X = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  function opt(list, key, extraSub) {
    return '<div class="plr-ch__opts" role="radiogroup">' + list.map(function (o) {
      var sub = extraSub && extraSub[o[0]] ? extraSub[o[0]] : o[2];
      return '<button type="button" class="plr-opt" role="radio" aria-checked="' + (ch[key] === o[0]) + '" data-set="' + key + '" data-val="' + o[0] + '"><span class="plr-opt__dot"></span><span class="plr-opt__t"><span>' + esc(o[1]) + '</span><small>' + esc(sub) + '</small></span></button>';
    }).join('') + '</div>';
  }
  function head(q1, sub) { return '<div><h3 class="plr-ch__q" tabindex="-1">' + esc(q1) + '</h3><p class="plr-ch__qsub">' + esc(sub) + '</p></div>'; }
  function cvalNote() {
    var s = seatInfo(Object.assign({}, ch, { counter: 'custom' }));
    return s.custom ? fmt(T.slider_custom, { s: s.seat }) : fmt(T.slider_standard, { s: s.seat, l: s.leg });
  }
  function lenNote() {
    var k = counts(Object.assign({}, ch, { lenSkip: false }));
    return fmt(T.len_note, { n: k.std, u: noun(k.std) }) + (k.slim !== k.std ? fmt(T.len_note_slim, { s: k.slim, v: noun(k.slim) }) : '') + (ch.walls ? (ch.walls === 2 ? T.len_note_wall2 : T.len_note_wall1) : '') + '.';
  }
  function asideRows() {
    var si = seatInfo(ch), k = counts(ch);
    var v = [
      si ? cm(si.seat) : (ch.counter === 'unsure' ? T.aside_unsure : null),
      ch.step > 2 && k ? (k.slim !== k.std ? fmt(T.aside_slim, { n: k.std, s: k.slim }) : String(k.std)) : null,
      ch.sit ? T.sit_txt[ch.sit] : null,
      ch.mat ? T.mat_txt[ch.mat] : null
    ];
    return T.aside_keys.map(function (key, i) {
      return '<div class="plr-aside__row"><span>' + esc(key) + '</span><b' + (v[i] ? '' : ' class="unset"') + '>' + esc(v[i] || T.not_set) + '</b></div>';
    }).join('');
  }
  function stepHtml() {
    var s = ch.step, h = '';
    if (s === 1) {
      h += head(T.q1, T.q1_sub) + opt(T.opts1, 'counter');
      if (ch.counter === 'custom') {
        h += '<div class="plr-box"><div class="plr-box__v"><b data-cvtxt>' + esc(cm(ch.cVal)) + '</b><span>' + esc(T.to_underside) + '</span></div>' +
          '<input type="range" min="80" max="115" step="1" value="' + ch.cVal + '" aria-label="' + esc(T.slider_aria) + '" data-cval>' +
          '<div class="plr-box__ends"><span>' + cm(80) + '</span><span>' + cm(115) + '</span></div><p data-cvnote>' + esc(cvalNote()) + '</p>' +
          '<button type="button" class="plr-btn" data-next>' + esc(T.next) + '</button></div>';
      } else if (ch.counter === 'unsure') {
        h += '<div class="plr-box plr-unsure"><svg viewBox="0 0 240 150" role="img" aria-label="' + esc(T.unsure_aria) + '"><path d="M10 140H230" stroke="#8A8780" stroke-width="1" fill="none"/><rect x="60" y="26" width="160" height="10" fill="#3D3B37"/><rect x="120" y="36" width="96" height="104" fill="none" stroke="#8A8780" stroke-width="1"/><path d="M84 138V40" stroke="#262522" stroke-width="1.25" fill="none"/><path d="M80 44l4-6 4 6M80 134l4 6 4-6" stroke="#262522" stroke-width="1.25" fill="none"/><path d="M70 37H98" stroke="#262522" stroke-width="1" stroke-dasharray="2 2" fill="none"/></svg>' +
          '<div style="display:flex;flex-direction:column;gap:12px"><p>' + esc(T.unsure_text) + '</p><div class="plr-unsure__acts"><button type="button" class="plr-btn plr-btn--2" data-set="counter" data-val="custom">' + esc(T.unsure_enter) + '</button><button type="button" class="plr-textbtn" data-next>' + esc(T.unsure_skip) + '</button></div></div></div>';
      }
    } else if (s === 2) {
      h += head(T.q2, T.q2_sub) + '<div class="plr-box"><div class="plr-box__v"><b data-lentxt>' + esc(cm(ch.len)) + '</b></div>' +
        '<input type="range" min="100" max="400" step="5" value="' + ch.len + '" aria-label="' + esc(T.len_aria) + '" data-len>' +
        '<div class="plr-box__ends"><span>' + cm(100) + '</span><span>' + cm(400) + '</span></div></div>' +
        '<div style="display:flex;flex-direction:column;gap:8px"><span style="font-size:15px;color:var(--ink)">' + esc(T.walls_q) + '</span><div class="plr-seg" role="radiogroup" aria-label="' + esc(T.walls_q) + '">' +
        T.walls.map(function (w, i) { return '<button type="button" role="radio" aria-checked="' + (ch.walls === i) + '" data-walls="' + i + '">' + esc(w) + '</button>'; }).join('') + '</div></div>' +
        '<p aria-live="polite" data-lennote style="font-size:15px">' + esc(lenNote()) + '</p><button type="button" class="plr-btn" data-next>' + esc(T.next) + '</button>';
    } else if (s === 3) {
      h += head(T.q3, T.q3_sub) + opt(T.opts3, 'sit');
    } else if (s === 4) {
      var si = seatInfo(ch);
      h += head(T.q4, T.q4_sub) + opt(T.opts4, 'mat', si && si.custom ? { oak: T.oak_sub_custom } : null);
    } else {
      h += resultHtml();
    }
    return h;
  }
  // Per-model facts from the dataset (production drawings): how many of THIS model fit, its width, footrest drop.
  function fitLine(m, k) {
    var parts = [];
    if (k && m.spacing) parts.push(fmt(T.fit, { n: Math.floor(k.eff / m.spacing), L: k.eff }));
    parts.push(fmt(T.fitw, { w: m.seat }));
    if (m.foot) parts.push(fmt(T.fitf, { f: m.foot }));
    return parts.join(' · ');
  }
  function resultHtml() {
    var r = result(ch), si = r.si;
    var seatFig = si ? cm(si.seat) : cm(66);
    var seatLabel = !si ? T.seat_label_unknown : (si.custom ? T.seat_label_custom : T.seat_label);
    var h = '<div class="plr-res"><h3 class="plr-vh plr-ch__q" tabindex="-1">' + esc(T.result_label) + '</h3><div class="plr-res__figs"><div><b>' + esc(seatFig) + '</b><span>' + esc(seatLabel) + '</span></div>';
    if (r.k) h += '<div><b>' + r.n + '</b><span>' + esc(fmt(r.n === 1 ? T.count_label_one : T.count_label, { l: ch.len })) + '</span></div>';
    h += '</div><p class="plr-res__why">' + esc(r.why) + '</p>';
    if (r.bd.length > 1) h += '<div class="plr-res__bd">' + r.bd.map(function (b) { return '<span>' + esc(b) + '</span>'; }).join('') + '</div>';
    if (r.note) h += '<div class="plr-note"><span class="plr-label plr-label--ink">' + esc(r.noteLabel) + '</span><p>' + esc(r.note) + '</p></div>';
    h += '<div class="plr-res__cards">' + r.rk.list.map(function (x, i) {
      var p = PROD[x.id] || {}, m = M[x.id];
      return '<a class="plr-rcard" href="' + esc(p.url || '#shop') + '" data-rpick="' + x.id + '" data-idx="' + (i + 1) + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="88" height="110" loading="lazy">' : '') +
        '<span class="plr-rcard__t"><span class="plr-label">' + esc(i === 0 ? T.best : T.also) + '</span><span class="plr-rcard__n">' + esc(fmt(U.title, { n: m.name })) + '</span><span class="plr-rcard__p">' + esc(p.price || '') + '</span>' +
        '<span class="plr-rcard__s">' + esc(x.sub) + '</span><span class="plr-rcard__r">' + esc(x.reason) + '</span>' +
        (T.fitw ? '<span class="plr-rcard__f">' + esc(fitLine(m, r.k)) + '</span>' : '') + '</span></a>';
    }).join('') + '</div>';
    h += '<div class="plr-res__links"><a href="' + esc(R + T.guide_height) + '" data-plr-guide="chooser">' + esc(T.why_height) + '</a><a href="' + esc(R + T.guide_count) + '" data-plr-guide="chooser">' + esc(T.how_many) + '</a></div>';
    h += '<div class="plr-res__acts"><button type="button" class="plr-btn" data-shopres>' + esc(fmt(T.shop, { n: r.rk.list.length })) + '</button><button type="button" class="plr-btn plr-btn--2" data-plr-samples="chooser">' + esc(T.samples) + '</button><button type="button" class="plr-textbtn" data-restart>' + esc(T.restart) + '</button></div></div>';
    ev('chooser_result', { seat: si ? si.seat : null, custom: !!(si && si.custom), count: r.n, picks: r.rk.list.map(function (x) { return x.id; }).join(','), conflict: r.rk.conflict });
    return h;
  }
  function render(focus) {
    var s = ch.step, mob = MOB.matches;
    var bars = [1, 2, 3, 4].map(function (i) { return '<span' + (i <= s ? ' class="on"' : '') + '></span>'; }).join('');
    var main = '<div class="plr-ch__main"><span class="plr-ch__handle" aria-hidden="true"></span>' +
      '<div class="plr-ch__top"><div><span class="plr-label plr-label--ink">' + esc(T.label) + '</span><span class="plr-label">' + esc(s <= 4 ? fmt(T.step, { n: s }) : T.result_label) + '</span></div>' +
      '<button type="button" class="plr-ch__close" data-close aria-label="' + esc(T.close) + '">' + ICON_X + '</button></div>' +
      '<div class="plr-ch__bars" aria-hidden="true">' + bars + '</div>' + stepHtml() +
      (s <= 4 ? '<div class="plr-ch__nav"><button type="button" data-back' + (s === 1 ? ' disabled' : '') + '>' + esc(T.back) + '</button><button type="button" data-skip>' + esc(T.skip) + '</button></div>' : '') + '</div>';
    var aside = !mob && s <= 4 ? '<aside class="plr-aside" aria-live="polite"><span class="plr-label">' + esc(T.aside_h) + '</span><div data-aside>' + asideRows() + '</div><p>' + esc(T.aside_foot) + '</p></aside>' : '';
    chEl.innerHTML = '<div class="plr-ch__scrim" data-scrim><div class="plr-ch__sheet" role="dialog" aria-label="' + esc(T.label) + '"' + (mob ? ' aria-modal="true"' : '') + '>' + main + aside + '</div></div>';
    chEl.classList.toggle('plr-ch--result', s > 4);
    if (focus !== false) { var hq = $('.plr-ch__q', chEl); if (hq) hq.focus({ preventScroll: !mob }); }
    save();
  }
  function setCh(o, focus) { Object.assign(ch, o); render(focus); }
  function openChooser(o, src) {
    trigger = document.activeElement;
    Object.assign(ch, o || {}, { open: true });
    chEl.hidden = false;
    entry.hidden = !MOB.matches;
    if (MOB.matches) document.documentElement.style.overflow = 'hidden';
    render();
    if (!MOB.matches) scrollToEl($('#find'));
    ev('chooser_open', { source: src || 'entry', step: ch.step });
    updSticky();
  }
  function closeChooser() {
    if (!ch.open) return;
    ch.open = false; chEl.hidden = true; entry.hidden = false; chEl.innerHTML = '';
    document.documentElement.style.overflow = '';
    save(); updSticky();
    if (trigger && trigger.focus) trigger.focus({ preventScroll: true });
  }
  function advance(to) { setTimeout(function () { setCh({ step: to }); }, 220); }
  chEl.addEventListener('click', function (e) {
    var t = e.target;
    if (t.matches('[data-scrim]') && MOB.matches) return closeChooser();
    var b = t.closest('button');
    if (!b) { var ra = t.closest('[data-rpick]'); if (ra) ev('select_item', { item_id: ra.dataset.rpick, index: +ra.dataset.idx, list: 'chooser' }); return; }
    if (b.hasAttribute('data-close')) return closeChooser();
    if (b.hasAttribute('data-set')) {
      var key = b.dataset.set, val = b.dataset.val, o = {}; o[key] = val;
      ev('chooser_step', { step: ch.step, value: val, skipped: false });
      if (key === 'counter') { setCh(o, val === 'custom' || val === 'unsure' ? false : undefined); if (val === 'std' || val === 'bar') advance(2); else { var inp = $('[data-cval]', chEl) || $('.plr-unsure button', chEl); if (inp) inp.focus(); } }
      else { setCh(o, false); advance(ch.step + 1); }
      return;
    }
    if (b.hasAttribute('data-walls')) { ch.walls = +b.dataset.walls; $$('[data-walls]', chEl).forEach(function (x) { x.setAttribute('aria-checked', String(x === b)); }); $('[data-lennote]', chEl).textContent = lenNote(); save(); return; }
    if (b.hasAttribute('data-next')) { ev('chooser_step', { step: ch.step, value: ch.step === 2 ? ch.len : ch.cVal, skipped: false }); return setCh({ step: Math.min(5, ch.step + 1), lenSkip: ch.step === 2 ? false : ch.lenSkip }); }
    if (b.hasAttribute('data-back')) return setCh({ step: Math.max(1, ch.step - 1) });
    if (b.hasAttribute('data-skip')) {
      ev('chooser_step', { step: ch.step, skipped: true });
      if (ch.step === 1) return setCh({ counter: null, step: 2 });
      if (ch.step === 2) return setCh({ lenSkip: true, step: 3 });
      if (ch.step === 3) return setCh({ sit: null, step: 4 });
      return setCh({ mat: 'any', step: 5 });
    }
    if (b.hasAttribute('data-restart')) { ch = Object.assign({}, BASE, { open: true }); return render(); }
    if (b.hasAttribute('data-shopres')) {
      matches = result(ch).rk.list.map(function (x) { return x.id; });
      store(':matches', matches);
      ev('chooser_shop', { n: matches.length });
      closeChooser(); showMatchChip(); setFilter('match'); scrollToEl($('#shop'));
    }
  });
  chEl.addEventListener('input', function (e) {
    var t = e.target;
    if (t.matches('[data-cval]')) { ch.cVal = +t.value; $('[data-cvtxt]', chEl).textContent = cm(ch.cVal); $('[data-cvnote]', chEl).textContent = cvalNote(); }
    if (t.matches('[data-len]')) { ch.len = +t.value; $('[data-lentxt]', chEl).textContent = cm(ch.len); $('[data-lennote]', chEl).textContent = lenNote(); }
    var a = $('[data-aside]', chEl); if (a) a.innerHTML = asideRows();
    save();
  });
  chEl.addEventListener('keydown', function (e) { trap(e, $('.plr-ch__sheet', chEl), MOB.matches, closeChooser); });
  $$('[data-plr-entry-opt]', root).forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var v = a.getAttribute('data-plr-entry-opt');
      openChooser({ counter: v, step: v === 'std' || v === 'bar' ? 2 : 1 }, 'entry');
    });
  });
  $$('[data-plr-find]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var src = a.getAttribute('data-plr-find');
      if (src === 'hero') ev('pillar_hero_cta', { cta: 'find' });
      if (!MOB.matches) scrollToEl($('#find'));
      openChooser({ step: ch.step }, src);
    });
  });
  MOB.addEventListener && MOB.addEventListener('change', function () { if (ch.open) { entry.hidden = !MOB.matches; document.documentElement.style.overflow = MOB.matches ? 'hidden' : ''; render(false); } });
  if (q.get('find')) openChooser({ step: Math.min(5, Math.max(1, +q.get('find') || 1)) }, 'link');

  /* Focus trap for modal surfaces; Esc closes. */
  function trap(e, box, modal, close) {
    if (e.key === 'Escape') { close(); return; }
    if (!modal || e.key !== 'Tab' || !box) return;
    var f = $$('a[href],button:not([disabled]),input,select,[tabindex]:not([tabindex="-1"])', box).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- before you choose: tabbed guide ---------- */
  var kn = $('[data-plr-kn]', root), ktabs = kn ? $$('[data-plr-ktab]', kn) : [];
  function kTab(id, focus, src) {
    ktabs.forEach(function (t) {
      var on = t.getAttribute('data-plr-ktab') === id;
      t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus();
      if (on && MOB.matches) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    });
    $$('.plr-kn__panel', kn).forEach(function (p) { p.classList.toggle('is-active', p.id === id); });
    if (src) ev('know_tab', { anchor: id, source: src });
  }
  ktabs.forEach(function (t, i) {
    t.addEventListener('click', function () { kTab(t.getAttribute('data-plr-ktab'), false, 'click'); });
    t.addEventListener('keydown', function (e) {
      var d = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[e.key];
      if (!d) return; e.preventDefault();
      kTab(ktabs[(i + d + ktabs.length) % ktabs.length].getAttribute('data-plr-ktab'), true, 'key');
    });
  });
  if (kn) kn.addEventListener('click', function (e) {
    var a = e.target.closest('[data-plr-act]'); if (!a) return;
    var act = a.getAttribute('data-plr-act').split(':');
    if (act[0] === 'chooser') { if (!MOB.matches) scrollToEl($('#find')); openChooser({ step: +act[1] }, 'know'); }
    if (act[0] === 'filter') { setFilter(act[1]); scrollToEl($('#shop')); }
  });
  /* ---------- pencil sketch renderer: overshooting double strokes, construction lines, loose hatching ---------- */
  function rng(seed) { return function () { seed = seed + 0x6D2B79F5 | 0; var t = Math.imul(seed ^ seed >>> 15, 1 | seed); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function f1(v) { return Math.round(v * 10) / 10; }
  var VE = ' vector-effect="non-scaling-stroke"';
  /* Architect drafting: one confident stroke per edge (a faint second pass only where asked), a small
     overshoot at the corners, hairline datum lines, dimension lines with 45-degree ticks, fine hatching. */
  function skLine(R, x1, y1, x2, y2, o) {
    o = o || {};
    var dx = x2 - x1, dy = y2 - y1, len = Math.hypot(dx, dy) || 1, ux = dx / len, uy = dy / len, nx = -uy, ny = ux, out = '';
    var over = o.over == null ? 3.5 : o.over, w = o.w || .9, op = o.op == null ? .92 : o.op;
    for (var p = 0; p < (o.double ? 2 : 1); p++) {
      var o1 = over * (.6 + R() * .7), o2 = over * (.6 + R() * .7), j = p ? .7 : .25;
      var ax = x1 - ux * o1 + nx * (R() - .5) * j, ay = y1 - uy * o1 + ny * (R() - .5) * j;
      var bx = x2 + ux * o2 + nx * (R() - .5) * j, by = y2 + uy * o2 + ny * (R() - .5) * j;
      var bow = (R() - .5) * (p ? .6 : .35), mx = (ax + bx) / 2 + nx * bow, my = (ay + by) / 2 + ny * bow;
      out += '<path d="M' + f1(ax) + ' ' + f1(ay) + 'Q' + f1(mx) + ' ' + f1(my) + ' ' + f1(bx) + ' ' + f1(by) + '" stroke-width="' + (p ? w * .5 : w) + '" opacity="' + (p ? op * .35 : op) + '"' + VE + '/>';
    }
    return out;
  }
  function datum(x1, y1, x2, y2) { return '<path d="M' + x1 + ' ' + y1 + 'L' + x2 + ' ' + y2 + '" stroke-width=".3" opacity=".22"' + VE + '/>'; }
  function tick(x, y) { return '<path d="M' + f1(x - 2.6) + ' ' + f1(y + 2.6) + 'L' + f1(x + 2.6) + ' ' + f1(y - 2.6) + '" stroke-width=".9" opacity=".85"' + VE + '/>'; }
  function dimV(R, x, y1, y2) { return skLine(R, x, y1, x, y2, { w: .5, op: .7, over: 1.5 }) + tick(x, y1) + tick(x, y2); }
  function dimH(R, x1, x2, y) { return skLine(R, x1, y, x2, y, { w: .5, op: .7, over: 1.5 }) + tick(x1, y) + tick(x2, y); }
  function skRect(R, x0, y0, x1, y1, o) {
    return skLine(R, x0, y0, x1, y0, o) + skLine(R, x1, y0, x1, y1, o) + skLine(R, x1, y1, x0, y1, o) + skLine(R, x0, y1, x0, y0, o);
  }
  function skHatch(R, x0, y0, x1, y1, gap, op) {
    var out = '', h = y1 - y0;
    for (var s = -h + gap / 2; s < x1 - x0; s += gap) {
      var ax = x0 + s, ay = y1, bx = x0 + s + h, by = y0;
      if (ax < x0) { ay -= (x0 - ax); ax = x0; }
      if (bx > x1) { by += (bx - x1); bx = x1; }
      if (bx - ax < 1) continue;
      out += '<path d="M' + f1(ax) + ' ' + f1(ay) + 'L' + f1(bx) + ' ' + f1(by) + '" stroke-width=".3" opacity="' + (op || .4) + '"' + VE + '/>';
    }
    return out;
  }
  /* Marker wash: broad parallel streaks along the long side, slightly off the ink lines. */
  function marker(R, x0, y0, x1, y1, color, op, dir) {
    /* One translucent, slightly irregular shape a little off the ink, plus a few faint streaks for texture. */
    var horiz = dir ? dir === 'h' : (x1 - x0) >= (y1 - y0), ox = .8 + R() * 1.6, oy = .6 + R() * 1.2;
    var j = function (v) { return f1(v + (R() - .5) * 2.2); };
    var d = 'M' + j(x0 + ox) + ' ' + j(y0 + oy) + 'L' + j(x1 + ox - R() * 3) + ' ' + j(y0 + oy) + 'L' + j(x1 + ox - R() * 2) + ' ' + j(y1 + oy) + 'L' + j(x0 + ox + R() * 2) + ' ' + j(y1 + oy) + 'Z';
    var out = '<path d="' + d + '" fill="' + color + '" stroke="none" opacity="' + op + '"/>';
    var n = 4, i;
    for (i = 0; i < n; i++) {
      if (horiz) { var y = y0 + (y1 - y0) * (i + .5) / n + oy; out += '<path d="M' + j(x0 + ox + 2) + ' ' + f1(y) + 'L' + j(x1 + ox - 4) + ' ' + f1(y + (R() - .5)) + '" stroke="' + color + '" stroke-width="' + f1(Math.max(1.2, (y1 - y0) / n * .5)) + '" opacity="' + f1(op * 35) / 100 + '" stroke-linecap="butt"/>'; }
      else { var x = x0 + (x1 - x0) * (i + .5) / n + ox; out += '<path d="M' + f1(x) + ' ' + j(y0 + oy + 2) + 'L' + f1(x + (R() - .5)) + ' ' + j(y1 + oy - 4) + '" stroke="' + color + '" stroke-width="' + f1(Math.max(1.2, (x1 - x0) / n * .5)) + '" opacity="' + f1(op * 35) / 100 + '" stroke-linecap="butt"/>'; }
    }
    return '<g style="mix-blend-mode:multiply">' + out + '</g>';
  }
  var MK = { stone: '#C9BFB1', leather: '#4B4845', oak: '#C49A6C', floor: '#D8CDBD' };
  function sketchHeight(svg) {
    var g = function (k) { return $('[data-sk="' + k + '"]', svg); }, R;
    R = rng(11); g('floor').innerHTML = marker(R, 20, 236, 320, 243, MK.oak, .28, 'h') + skLine(R, 10, 236, 330, 236, { w: .9, over: 4 }) + datum(4, 236, 336, 236);
    var slats = ''; for (var sx = 224; sx < 318; sx += 7.5) slats += '<path d="M' + sx + ' 60V232" stroke-width=".35" opacity=".28"' + VE + '/>';
    R = rng(12); g('cab').innerHTML = marker(R, 216, 56, 322, 236, MK.stone, .35, 'v') + slats + skLine(R, 216, 56, 216, 236, { w: .9, op: .85, over: 4 }) + skLine(R, 322, 56, 322, 236, { w: .9, op: .85, over: 4 });
    R = rng(13); g('dim').innerHTML = dimV(R, 44, 96, 236);
    R = rng(14); g('legs').innerHTML = skLine(R, 70, 106, 70, 236, { w: 1.1, over: 4 }) + skLine(R, 150, 106, 150, 236, { w: 1.1, over: 4 });
    R = rng(15); g('runner').innerHTML = skLine(R, 70, 233, 150, 233, { w: 1, over: 4 });
    R = rng(16); g('top').innerHTML = marker(R, 140, 48, 332, 56, MK.stone, .7, 'h') + skRect(R, 140, 48, 332, 56, { w: 1, over: 5 }) + skHatch(R, 140, 48, 332, 56, 3.2, .3) + datum(24, 56, 336, 56);
    R = rng(17); g('stool').innerHTML = skLine(R, 70, 68, 70, 107, { w: 1 }) + skLine(R, 70, 105.5, 151, 105.5, { w: .8 }) +
      marker(R, 70.5, 96, 151, 103.5, MK.leather, .55, 'h') + skRect(R, 70.5, 96, 151, 103.5, { w: 1, over: 4 }) +
      datum(24, 96, 200, 96) + dimV(R, 160, 56, 96);
  }
  var cplan = null;
  function drawPlan(L) {
    if (!cplan) return;
    var W = Math.round(L * 300 / 360), x0 = Math.round((340 - W) / 2), nS = Math.floor(L / 55), R = rng(21), h = '';
    h += marker(R, x0, 36, x0 + W, 108, MK.stone, .55, 'h') + skRect(R, x0, 36, x0 + W, 108, { w: 1, over: 6 });
    h += datum(x0 - 20, 36, x0 + W + 20, 36) + datum(x0, 24, x0, 176) + datum(x0 + W, 24, x0 + W, 176);
    for (var i = 0; i < nS; i++) {
      var cx = x0 + (i + .5) * W / nS, Ri = rng(40 + i);
      h += marker(Ri, cx - 15, 118, cx + 15, 146, MK.leather, .5, 'v') + skRect(Ri, cx - 15, 118, cx + 15, 146, { w: .95, over: 3.5 });
    }
    h += dimH(R, x0, x0 + W, 166);
    cplan.innerHTML = h;
  }
  $$('[data-plr-sketch="height"]', root).forEach(sketchHeight);

  var hcard = $('[data-plr-hcard]', root);
  if (hcard) $$('[data-plr-hmode]', hcard).forEach(function (b) {
    b.addEventListener('click', function () {
      var bar = b.dataset.plrHmode === 'bar', mode = bar ? 'bar' : 'island';
      hcard.classList.toggle('is-bar', bar);
      $$('[data-plr-hmode]', hcard).forEach(function (x) { x.setAttribute('aria-checked', String(x === b)); });
      $$('[data-plr-hfig]', hcard).forEach(function (x) { x.textContent = x.getAttribute('data-' + mode); });
      var st = $('[data-plr-hst]', hcard); st.textContent = st.getAttribute('data-' + mode);
      var sv = $('.plr-hsvg', hcard); sv.setAttribute('aria-label', sv.getAttribute('data-aria-' + mode));
      ev('know_interact', { anchor: 'height', value: mode });
    });
  });
  var ccard = $('[data-plr-ccard]', root), KC = (D.know && D.know.count) || {};
  if (ccard) {
  cplan = $('[data-plr-cplan]', ccard); drawPlan(+$('[data-plr-cslider]', ccard).value);
  $('[data-plr-cslider]', ccard).addEventListener('input', function (e) {
    var L = +e.target.value, W = Math.round(L * 300 / 360), x0 = Math.round((340 - W) / 2), nS = Math.floor(L / 55), nL = Math.floor(L / 50);
    drawPlan(L);
    $('[data-plr-clen]', ccard).textContent = cm(L);
    $('[data-plr-cst]', ccard).textContent = fmt(nS === 1 ? KC.statement_one : KC.statement, { n: nS, l: L });
    $('[data-plr-cline]', ccard).textContent = nL > nS ? fmt(KC.line_more, { s: nL }) : KC.line_same;
    $('[data-plr-csvg]', ccard).setAttribute('aria-label', fmt(KC.aria, { l: L, n: nS }));
  });
  $('[data-plr-cslider]', ccard).addEventListener('change', function (e) { ev('know_interact', { anchor: 'how-many', value: +e.target.value }); });
  }

  var openDet = null, detTrigger = null;
  function openDetail(id, from) {
    var d = $('[data-plr-detail="' + id + '"]', root);
    if (!d) return;
    closeDetail();
    detTrigger = from || document.activeElement;
    d.classList.add('is-open'); openDet = d;
    document.documentElement.style.overflow = 'hidden';
    $('.plr-det__panel', d).focus();
    if (id === 'tp') loadTrustpilot(d);
    ev('know_detail_open', { anchor: id });
    updSticky();
  }
  // Official Trustpilot bootstrap, once per page (same id as the PDP loader, so never twice).
  function loadTrustpilot(d) {
    var el = $('.trustpilot-widget', d);
    if (!el || el.getAttribute('data-plr-tp-done')) return;
    function render() {
      if (!(window.Trustpilot && window.Trustpilot.loadFromElement)) return false;
      try { window.Trustpilot.loadFromElement(el, true); el.setAttribute('data-plr-tp-done', '1'); } catch (e) {}
      return true;
    }
    if (render()) return;
    if (!document.getElementById('tp-bootstrap-script')) {
      var sc = document.createElement('script');
      sc.id = 'tp-bootstrap-script'; sc.async = true;
      sc.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      document.head.appendChild(sc);
    }
    var tries = 0;
    (function retry() { if (render()) return; if (tries++ < 60) setTimeout(retry, 250); })();
  }
  function closeDetail() {
    if (!openDet) return;
    openDet.classList.remove('is-open'); openDet = null;
    document.documentElement.style.overflow = '';
    if (detTrigger && detTrigger.focus) detTrigger.focus({ preventScroll: true });
    updSticky();
  }
  $$('[data-plr-det]', root).forEach(function (b) { b.addEventListener('click', function () { openDetail(b.getAttribute('data-plr-det'), b); }); });
  $$('[data-plr-detail]', root).forEach(function (d) {
    d.addEventListener('click', function (e) {
      if (e.target === d || e.target.closest('[data-plr-close]')) return closeDetail();
      var a = e.target.closest('[data-plr-act]');
      if (!a) return;
      var act = a.getAttribute('data-plr-act').split(':');
      detTrigger = null; closeDetail();
      if (act[0] === 'chooser') { if (!MOB.matches) scrollToEl($('#find')); openChooser({ step: +act[1] }, 'module'); }
      if (act[0] === 'filter') { setFilter(act[1]); scrollToEl($('#shop')); }
    });
    d.addEventListener('keydown', function (e) { trap(e, $('.plr-det__panel', d), true, closeDetail); });
  });
  function fromHash() {
    if (!kn) return;
    var id = q.get('detail') || location.hash.slice(1);
    if (!$('[data-plr-ktab="' + id + '"]', kn)) return;
    kTab(id, false, 'link'); scrollToEl($('#know'));
  }
  window.addEventListener('hashchange', fromHash);
  fromHash();

  /* ---------- shipping calculator: checkout's own weight bands, in the visitor's currency ---------- */
  var shipEl = $('[data-plr-ship]', root), SH = D.ship;
  if (shipEl && SH && SH.zones) {
    var country = shipEl.getAttribute('data-country'), zone = null;
    SH.zones.forEach(function (z) { if (z.countries.indexOf(country) > -1) zone = z; });
    var cur = (window.Shopify && Shopify.currency) || {}, active = cur.active, rate = parseFloat(cur.rate) || 1;
    var convertible = zone && (zone.currency === active || zone.currency === 'EUR');
    if (convertible) {
      var n = 2, sel = $('[data-plr-ship-model]', shipEl), out = $('[data-plr-ship-price]', shipEl), nEl = $('[data-plr-ship-n]', shipEl);
      var fmtMoney = function (v) {
        var whole = Math.abs(v - Math.round(v)) < .005;
        try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: active, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(v); }
        catch (e) { return v.toFixed(2) + ' ' + active; }
      };
      var calc = function () {
        var kg = (SH.weights[sel.value] || 7) * n, price = null;
        for (var i = 0; i < zone.bands.length; i++) { var b = zone.bands[i]; if (b[0] === null || kg <= b[0] + 1e-9) { price = b[1]; break; } }
        if (price === null) return;
        var shopCur = SH.shop_currency || 'EUR', about = zone.currency !== shopCur, v;
        if (zone.currency === active && !about) v = price;
        else if (zone.currency === active) v = Math.round(price * (SH.fx_fee || 1) * 100) / 100;   /* checkout converts via EUR */
        else v = Math.round(price * rate * 100) / 100;                                                 /* EUR zone in another currency: exact */
        var note = $('.plr-ship__note', shipEl);
        nEl.textContent = n;
        out.textContent = about ? note.getAttribute('data-about-fmt').replace('%p', fmtMoney(v)) : fmtMoney(v);
        note.textContent = about ? note.getAttribute('data-about') : note.getAttribute('data-exact');
      };
      sel.addEventListener('change', calc);
      $$('[data-plr-ship-step]', shipEl).forEach(function (b) { b.addEventListener('click', function () { n = Math.min(12, Math.max(1, n + +b.getAttribute('data-plr-ship-step'))); calc(); }); });
      calc(); shipEl.hidden = false;
    }
  }

  /* ---------- compare pickers ---------- */
  var cmp = $('[data-plr-cmp]', root);
  if (cmp) {
    var table = $('table', cmp), rows = $$('tr', table).filter(function (tr) { return tr.querySelector('[data-col]'); });
    var all = $$('thead th', table).map(function (th) { return th.dataset.col; });
    // Each <select> ships with its own model only; fill the full list once, client side.
    $$('select[data-plr-pick]', table).forEach(function (s) {
      var cur = s.value;
      s.innerHTML = all.map(function (id) { return '<option value="' + id + '">' + esc(M[id] ? M[id].name : id) + '</option>'; }).join('');
      s.value = cur;
    });
    var sel = (store(':cmp') || all.slice(0, 4)).filter(function (id) { return all.indexOf(id) > -1; });
    if (sel.length < 4) sel = all.slice(0, 4);
    var applyCmp = function () {
      var order = sel.concat(all.filter(function (id) { return sel.indexOf(id) < 0; }));
      rows.forEach(function (tr) {
        order.forEach(function (id, i) {
          var cell = $('[data-col="' + id + '"]', tr);
          cell.classList.toggle('is-m', i < 2); cell.classList.toggle('is-d', i < 4);
          tr.appendChild(cell);
        });
      });
      $$('select', table).forEach(function (s) { s.value = s.closest('th').dataset.col; });
      store(':cmp', sel);
    };
    table.addEventListener('change', function (e) {
      var s = e.target; if (!s.matches('[data-plr-pick]')) return;
      var from = s.closest('th').dataset.col, i = sel.indexOf(from), v = s.value, j = sel.indexOf(v);
      if (i < 0) return;
      if (j > -1) sel[j] = sel[i];
      sel[i] = v;
      applyCmp();
      ev('compare_pick', { column: i + 1, model: v });
      var th = $('th[data-col="' + v + '"] select', table); if (th) th.focus();
    });
    applyCmp();
  }

  /* ---------- guides and FAQ ---------- */
  if (lib) {
    $$('[data-plr-grow]', lib).forEach(function (g) {
      var b = $('[data-plr-gtoggle]', g);
      function set(open) { g.classList.toggle('is-open', open); b.setAttribute('aria-expanded', String(open)); }
      b.addEventListener('click', function () { var o = !g.classList.contains('is-open'); set(o); if (o) ev('guides_expand', { group: g.dataset.plrGrow }); });
      if (q.get('gx') === g.dataset.plrGrow || location.hash.slice(1) === g.dataset.plrGrow) set(true);
    });
    var fb = $$('[data-plr-faq]', lib);
    function faq(i) {
      fb.forEach(function (b, j) { var o = j === i; b.setAttribute('aria-expanded', String(o)); document.getElementById(b.getAttribute('aria-controls')).hidden = !o; });
    }
    fb.forEach(function (b, i) { b.addEventListener('click', function () { var o = b.getAttribute('aria-expanded') === 'true'; faq(o ? -1 : i); if (!o) ev('faq_open', { index: i + 1 }); }); });
    faq(0);
  }

  /* ---------- mobile sticky bar ---------- */
  var sticky = lib && $('[data-plr-sticky]', lib), vis = { hero: true, grid: false, foot: false };
  function samplesOpen() { var d = document.querySelector('.pdp-samples'); return d && d.classList.contains('is-open'); }
  function updSticky() {
    if (!sticky) return;
    var show = MOB.matches && !vis.hero && !vis.grid && !vis.foot && !ch.open && !openDet && !samplesOpen();
    sticky.hidden = !show;
    var s = $('[data-plr-sticky-shop]', sticky);
    s.textContent = matches ? fmt(U.sticky_matches, { n: matches.length }) : s.getAttribute('data-all');
  }
  if (sticky && 'IntersectionObserver' in window) {
    var foot = document.querySelector('footer, .shopify-section-group-footer-group');
    var targets = [[$('[data-io="hero"]', root), 'hero'], [$('#shop', root), 'grid'], [foot, 'foot']];
    var sio = new IntersectionObserver(function (es) { es.forEach(function (x) { vis[x.target.__plr] = x.isIntersecting; }); updSticky(); });
    targets.forEach(function (t) { if (t[0]) { t[0].__plr = t[1]; sio.observe(t[0]); } });
    document.addEventListener('click', function () { setTimeout(updSticky, 50); });
  }
})();
